<script setup lang="ts">
import YellowAiTip from "@/widgets/common/YellowAiTip.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="banners-header-text__wrapper">
    <div class="selected-items__header-title">
      <span class="selected-items_title h1">{{
        t("home_page.selected_for_you.title")
      }}</span>
      <yellow-ai-tip :ai-tip-text="t('ai_tips.based_on_search_history')" />
    </div>
  </div>
</template>

<style scoped>
.banners-header-text__wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 90%;
  padding-bottom: 20px;
}

.selected-items__header-title {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.selected-items_title {
  color: rgba(35, 47, 69, 1);
}

@media (max-width: 1024px) {
  .banners-header-text__wrapper {
    padding: 16px;
  }
}
</style>
